export  const  routes={
    home:'/home',
    aboutMe:'/about-me',
    skills:'/slills',
    myProjects:'/my-projects',
    contact:'/contact',
    error404:'/404'
}